import React from "react";
import MyDatePicker from "./DatePicker";
import DatePicker from 'react-datepicker';
import FixButton from './Button';
import OnlyDatePicker from "./OnlyDatePicker";
import moment from "moment";

export default class SelectDateInterval extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isDatePickerShowing: false,
            visible: false,
            errorInStartDate: false,
            errorInEndDate: false,
            eventStartDate: null, 
            eventEndDate: null, 
            selectedStartDate: null, 
            selectedEndDate: null
        }
    }

    componentDidMount() {

        // Date is in dd/mm/yyyy format
        const startDateString = this.props.startDate[3] + this.props.startDate[4] + "/" + this.props.startDate[0] + this.props.startDate[1] + "/" + this.props.startDate.slice(-4);
        const endDateString = this.props.endDate[3] + this.props.endDate[4] + "/" + this.props.endDate[0] + this.props.endDate[1] + "/" + this.props.endDate.slice(-4);
        
        const startDate = new Date(startDateString);
        const endDate = new Date(endDateString);
        this.setState({ eventStartDate: startDate, selectedStartDate: startDate, eventEndDate: endDate, selectedEndDate: endDate });

        // Show popup to the user 
        this.setState({ visible: true });
    };

    checkForStartDate(date) {
        console.log(date);
        if(date < this.state.eventStartDate || date > this.state.eventEndDate || date > this.state.selectedEndDate) {
            this.setState({ errorInStartDate: true });
        } else {
            this.setState({ errorInStartDate: false });
        }
    }

    checkForEndDate(date) {
        if(date < this.state.eventStartDate || date > this.state.eventEndDate || date < this.state.selectedStartDate) {
            this.setState({ errorInEndDate: true });
        } else {
            this.setState({ errorInEndDate: false });
        }
    }

    checkAndGenerateRequestedPDF() {
        if (!this.state.errorInStartDate && !this.state.errorInEndDate) {
            this.props.onDone(this.state.selectedStartDate, this.state.selectedEndDate);
            this.setState({ visible: false });
        } else {
            alert("Please check the selected time interval.");
        }
    }

    render() {

        let st = Object.assign({display: this.state.visible ? 'block' : 'none'}, mainClass)
        const ExampleCustomInput = ({ value, onClick }) => (
            <div style={{width: '300px', height: '40px', border: '1px solid black', lineHeight: '40px', paddingLeft: '10px', background: '#ffffff'}} onClick={onClick}>
              {value}
            </div>
          );

        return(
            <div style={container}>
                <div style={st} >
                    <div style={closeIcon} onClick={() => {
                        this.setState({visible: false});
                        this.props.onDone(null, null);
                    }}>X</div>
                    <div className="windowTitle">Generate PDF</div>
                    <br/><br/>
                    <div className="pickersDiv"> 
                        <OnlyDatePicker value={this.state.selectedStartDate} name={'Start date'} setDate={(date) => { 
                            this.checkForStartDate(date);
                            this.setState({ selectedStartDate: date });
                        }} />
                        <br/>
                        <OnlyDatePicker value={this.state.selectedEndDate} name={'End date'} setDate={(date) => { 
                            this.checkForEndDate(date);
                            this.setState({ selectedEndDate: date });
                        }} />      
                    </div>
                    { (this.state.errorInStartDate || this.state.errorInEndDate) && (
                        <div>
                            <p style={{color: 'red'}}>Invalid time interval. Please check dates.</p>
                        </div>
                    )}
                    <div style={{position: 'absolute', right: '20px', bottom: '20px'}}>
                        <FixButton title={'Generate'} callback={() => this.checkAndGenerateRequestedPDF()} />
                    </div>
                </div>  
            </div>
        );
    }
}

const mainClass = {
    position: 'fixed',
    left: '35%',
    top: '10%',
    background: '#ffffff',
    border: '1px solid black',
    padding: '20px',
    overflow: 'scroll',
    height: '600px',
    zIndex: 999
};

const closeIcon = {
    position: 'absolute', 
    cursor: 'pointer',
    right: 10, 
    top: 10, 
    padding: 10
};

const container = {
    position: 'fixed',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    background: '#ffffff88'
}
